import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
const baseClassName = 'text-blue-600 hover:underline cursor-pointer whitespace-nowrap';
function isExternalUrl(to) {
    return /^https?:\/\/|^\/\//.test(to);
}
/**
 * Clickable button styled as a blue link.
 * Use for in-page actions (open modal, pane, download, etc.).
 */
export function LinkButton({ children, onClick, className = '', }) {
    return (React.createElement("button", { type: "button", className: `${baseClassName} ${className}`, onClick: onClick }, children));
}
/**
 * Navigation link styled as a blue link.
 *
 * Renders <a target="_blank"> when:
 * - URL is external (https://, http://, //)
 * - `external` prop is true (e.g. internal route that should open in new tab)
 *
 * Otherwise renders React Router <Link> for SPA navigation.
 * External URLs automatically show an external link icon.
 */
export function AppLink({ children, to, external = false, className = '', }) {
    const isExternal = isExternalUrl(to);
    if (external || isExternal) {
        return (React.createElement("a", { href: to, className: `${baseClassName} group inline-flex items-center gap-1 ${className}`, target: "_blank", rel: "noopener noreferrer" },
            children,
            React.createElement(ExternalLink, { className: "h-3 w-3 shrink-0 opacity-50 group-hover:opacity-100 transition-opacity" })));
    }
    return (React.createElement(Link, { to: to, className: `${baseClassName} ${className}` }, children));
}
